import React from 'react'

import Text from '../../../../../../components/pdf/Text'
import Line from '../../../../../../components/pdf/Line'
import Separator from '../../../../../../components/pdf/Separator'

export const ContratoSection = ({ clientInfo }) => {
  return (
    <div id="contrato">
      <Text semibold size="h3">
        Contrato de prestação de serviços e licença de uso de Software
      </Text>
      <Line />
      <Separator weight={5} />
      <>
        <Text align="justify">
          <b>CONTRATADA: BTIME SOLUÇÕES LTDA.</b>, inscrita no CNPJ/MF sob o nº. 21.849.504/0001-50, com sede na Alameda
          Vicente Pizon, n°. 54, Vila Olímpia, São Paulo/SP, CEP 04547-130, neste ato representada de acordo com seus
          atos constitutivos, de agora em diante denominada simplesmente <b>“BTIME”</b>; e, do outro lado;
        </Text>
        <Separator weight={5} />
        <Text align="justify">
          <b>CONTRATANTE:</b> <b>{clientInfo.razaoSocial}</b>, inscrita no CNPJ/MF sob o n° {clientInfo.cnpj},{' '}
          {clientInfo.nomeFantasia && `nome comercial ${clientInfo.nomeFantasia}, `}
          {clientInfo.inscricaoEstadual && `IE ${clientInfo.inscricaoEstadual}, `}
          {clientInfo.inscricaoMunicipal && `IM ${clientInfo.inscricaoMunicipal}, `}
          com sede em{' '}
          {clientInfo.complement ? `${clientInfo.address} - ${clientInfo.complement}` : `${clientInfo.address}`}, neste
          ato representada de acordo com seus atos constitutivos, de agora em diante denominada simplesmente{' '}
          <b>“CONTRATANTE”</b>.
        </Text>
        <Separator weight={5} />
      </>

      <Text align="justify">
        Pelo presente instrumento particular, as partes acima qualificadas têm entre si, justo e acordado, o presente
        Contrato de Prestação de Serviços e Licença de Uso de Software, o qual será regido pelas cláusulas e condições a
        seguir, que mutuamente aceitam e outorgam, a saber:
      </Text>
      <Separator weight={5} />

      <Text semibold>
        <u>DO OBJETO</u>
      </Text>
      <Separator weight={2} />
      <ul>
        <li>
          <Text align="justify">
            Pelo presente instrumento, a <b>BTIME</b> se obriga a prestar o serviço de disponibilização do{' '}
            <b>SOFTWARE</b>, e sua respectiva licença de uso, não exclusiva e intransferível, em favor da{' '}
            <b>CONTRATANTE</b>, de acordo com os prazos e as condições definidas neste contrato e em seus ANEXOS,
            consubstanciados na(s) <b>PROPOSTA(S) BTIME</b> que venha(m) a ser firmada(s) entre as Partes e que passarão
            a ser parte integrante(s) e indissociável(is) do presente instrumento.
          </Text>
        </li>
        <Separator weight={2} />

        <li>
          <Text align="justify">
            Adicionalmente à disponibilização do <b>SOFTWARE</b>, a <b>BTIME</b> se compromete a prestar serviços de
            implantação do <b>SOFTWARE</b>, bem como os serviços de suporte e atualização deste.
          </Text>
        </li>
      </ul>

      <Separator weight={5} />

      <Text semibold>
        <u>DOS MÓDULOS DISPONIBILIZADOS</u>
      </Text>
      <Separator weight={2} />

      <Text align="justify">
        <b>2.1.</b> O <b>SOFTWARE</b> disponibilizado pela <b>BTIME</b> tem natureza de modelo “SaaS” (Software as a
        Service), cuja informações são hospedadas atualmente na nuvem <b>Microsoft Azure</b> e acessadas remotamente
        pela <b>CONTRATANTE</b>, sendo composto por diversos módulos, sendo disponibilizados à CONTRATANTE unicamente os
        módulos contratados, os quais estão expressamente listados e precificados no(s) <b>ANEXO(S)</b>.
      </Text>

      <Separator weight={2} />

      <Text align="justify">
        <b>2.1.1.</b> A nuvem em que as informações estão hospedadas poderá ser alterada, evento que poderá ser
        previamente comunicado à <b>CONTRATANTE</b>. Nesse caso, serão mantidos todos os níveis de serviços com o mesmo
        nível de segurança e confiabilidade e não ocorrerá qualquer interrupção dos serviços oferecidos.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DOS SERVIÇOS DE IMPLANTAÇÃO, SUPORTE, E ATUALIZAÇÃO DO SOFTWARE</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>3.1.</b> Os serviços relacionados ao <b>SOFTWARE</b> compreendem os serviços de: Acessos, Onboarding,
        Professional Services e Consultoria, Manutenção, Treinamento, Informação e Suporte; entre outros serviços
        eventualmente previstos na <b>PROPOSTA BTIME</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>3.1.1.</b> A alimentação de bases de dados do <b>SOFTWARE</b> será de responsabilidade da <b>CONTRATANTE</b>,
        e pode ser realizada pela <b>BTIME</b> desde que haja prévia autorização e aprovação do conteúdo pela{' '}
        <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>3.1.2.</b> Os treinamentos deverão ser de acordo com os limites previstos na <b>PROPOSTA BTIME</b> quanto à
        quantidade e pessoas por turma.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>3.1.3.</b> As despesas de hospedagem e locomoção para fora do município de São Paulo são de responsabilidade
        da <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>3.2.</b> Durante a vigência deste contrato, a <b>BTIME</b> disponibilizará suporte pelo e-mail{' '}
        <a href="mailto:suporte@btime.com.br" style={{ textDecoration: 'none', color: 'inherit' }}>
          suporte@btime.com.br
        </a>
        , e chat na solução, para os administradores da Plataforma eleitos pela <b>CONTRATANTE</b>, de segunda a
        sexta-feira, das 09h:00am às 18h:00pm, exceto sábados, domingos e feriados.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>3.3.</b> A <b>BTIME</b> manterá o <b>SOFTWARE</b> atualizado em seus servidores, disponibilizando à{' '}
        <b>CONTRATANTE</b> sempre a última versão homologada durante a vigência deste contrato.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DO PREÇO E FORMA DE PAGAMENTO</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>4.1.</b> Pela prestação dos serviços objeto deste contrato, a <b>CONTRATANTE</b> se obriga a pagar:
      </Text>
      <Separator weight={2} />
      <div style={{ paddingLeft: 10 }}>
        <Text align="justify">
          <b>1.</b> O valor da <b>TAXA DE IMPLANTAÇÃO</b> e dos <b>MÓDULOS</b> previsto no(s) <b>ANEXO(S)</b> deste
          contrato, de acordo com as quantias e condições de pagamento nele(s) descritas; e
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>2.</b> No último dia de cada mês será feita a apuração das licenças em uso, bem como os módulos, sendo
          gerada a fatura para pagamento até a data acordada no(s) <b>ANEXO(S)</b>.
        </Text>
      </div>
      <Separator weight={2} />
      <Text align="justify">
        <b>4.2.</b> Para pagamentos provenientes do exterior, é de responsabilidade da <b>CONTRATANTE</b> quaisquer
        taxas de exportação de serviços e/ou variações cambiais que venham a incidir, devendo a <b>BTIME</b> receber o
        valor líquido total através de transferência bancária internacional.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>4.3.</b> No caso de atraso de qualquer pagamento previsto neste contrato ou nos <b>ANEXO(S)</b>, a{' '}
        <b>CONTRATANTE</b> ficará sujeita ao pagamento do valor devido acrescido de juros de mora de 1% (um por cento)
        ao mês, multa moratória de 02% (dois por cento) e correção monetária pelo índice IPCA.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>4.4.</b> No caso de inadimplência por período superior a 30 (trinta) dias, é lícito à <b>BTIME</b> suspender
        a prestação dos serviços, independentemente de qualquer aviso, notificação, ou formalidade adicional, sem
        prejuízo da cobrança do débito, observado, ainda, no caso de inadimplência superior a 60 (sessenta) dias, o
        direito de a <b>BTIME</b> proceder com a rescisão contratual.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>4.5.</b> Os valores previstos neste contrato e seus <b>ANEXO(S)</b> serão reajustados a cada 12 (doze) meses,
        aplicando correção monetária com base no IPCA, ou outro índice que venha a substituí-lo, no caso de sua
        extinção.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>4.6.</b> <b>Manutenção da Mensalidade Mínima e Custos Operacionais:</b> A precificação dos serviços objeto
        deste Contrato é baseada na disponibilidade contínua e integral da plataforma, bem como nos parâmetros de uso
        contratados, podendo haver cobranças adicionais por excedentes de atividades, usuários, locais ou outros
        critérios previamente definidos. Contudo, o valor da mensalidade base e/ou dos componentes fixos da assinatura
        não será reduzido, congelado ou suspenso em decorrência de menor utilização da plataforma ou de seus recursos
        por parte do <b>CONTRATANTE</b>. Os custos operacionais de manutenção, hospedagem, segurança e disponibilidade
        do software são independentes do volume de uso individual do <b>CONTRATANTE</b>, justificando a regularidade das
        cobranças pactuadas.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DAS OBRIGAÇÕES DAS PARTES</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>5.1.</b> Sem prejuízo das demais obrigações previstas neste contrato, a <b>CONTRATANTE</b> se obriga a:
      </Text>
      <Separator weight={2} />
      <div style={{ paddingLeft: 10 }}>
        <Text align="justify">
          <b>1.</b> Fornecer à <b>BTIME</b>, a qualquer tempo, todas as informações necessárias para a execução do
          objeto deste contrato, com o máximo de presteza;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>2.</b> Zelar pelo <b>SOFTWARE</b> objeto deste contrato, impedindo que terceiros venham a ter acesso à
          tecnologia e ao <i>know-how</i> empreendidos para seu desenvolvimento e implantação;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>3.</b> Respeitar e envidar seus melhores esforços para que seus diretores, empregados, prepostos, e
          quaisquer terceiros a seu serviço, respeitem os direitos da <b>BTIME</b> sobre o <b>SOFTWARE</b>;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>4.</b> Notificar a <b>BTIME</b>, imediatamente, caso venha a ter conhecimento de qualquer violação dos seus
          direitos sobre o <b>SOFTWARE</b>, auxiliando a <b>BTIME</b> na defesa de seus direitos;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>5.</b> Responder pelos danos eventualmente causados à <b>BTIME</b> ou a terceiros, por atos de
          responsabilidade da <b>CONTRATANTE</b> ou de seus prepostos.
        </Text>
      </div>
      <Separator weight={2} />
      <Text align="justify">
        <b>5.2.</b> Sem prejuízo das demais obrigações previstas neste contrato, a <b>BTIME</b> se obriga a:
      </Text>
      <Separator weight={2} />
      <div style={{ paddingLeft: 10 }}>
        <Text align="justify">
          <b>1.</b> Executar os serviços objeto deste instrumento de modo a atingir suas finalidades, nos termos deste
          contrato e do(s) <b>ANEXO(S)</b>;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>2.</b> Diligenciar para atender satisfatoriamente às necessidades da <b>CONTRATANTE</b> provendo todo
          amparo no objeto deste contrato;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>3.</b> Empregar, continuamente, as melhores técnicas, tecnologias e materiais, visando a melhoria e
          otimização de seus processos, de forma a traduzir sua prática em benefícios reais para a <b>CONTRATANTE</b>;
        </Text>
        <Separator weight={2} />
        <Text align="justify">
          <b>4.</b> Assumir todos os encargos trabalhistas, securitários, previdenciários, e quaisquer outros relativos
          à mão de obra que empregar na execução do objeto deste contrato.
        </Text>
      </div>

      <Separator weight={5} />

      <Text semibold>
        <u>DAS LIMITAÇÕES DE RESPONSABILIDADE</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.1.</b> A <b>BTIME</b> usará seus melhores esforços para que os servidores que hospedam o <b>SOFTWARE</b>{' '}
        funcionem com alta confiabilidade. Porém, a <b>CONTRATANTE</b> declara ciência de que o funcionamento desses
        servidores poderá ser afetado por inúmeros fatores, todos fora do controle e diligência da <b>BTIME</b>, tais
        como falhas nas operadoras interconectadas à rede, eventos de força maior, caso fortuito, e outros, motivo pelo
        qual a <b>BTIME</b> não garante funcionamento ininterrupto desses equipamentos.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.2.</b> A <b>BTIME</b> não se responsabiliza por perdas e danos causados, de qualquer tipo ou natureza, pela
        utilização irregular dos serviços por ela prestados, ou em função de problemas de software, sistemas e
        aplicativos de terceiros, ou hardware, de responsabilidade exclusiva de seus fabricantes, bem como por perdas de
        dados, vírus, e quaisquer outros eventos que fujam ao controle e diligência da <b>BTIME</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.3.</b> A <b>BTIME</b> não garante, sob nenhuma hipótese, que os sistemas de conexão com os serviços (via
        telefônica, via cabo, ou qualquer outro) estejam livres de possíveis falhas ou interrupções, não se
        responsabilizando pela qualidade da rede utilizada para acesso ao serviço, vez que esta é mantida por terceiros,
        que não a <b>BTIME</b>, e, portanto, foge do seu controle, diligência e responsabilidade.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.4.</b> Todas as credenciais de acesso (usuários e/ou senhas) fornecidas à <b>CONTRATANTE</b>, e/ou criadas
        pela <b>CONTRATANTE</b>, para utilização do serviço e do <b>SOFTWARE</b>, são pessoais e intransferíveis,
        ficando a <b>CONTRATANTE</b> responsável exclusiva por toda e qualquer utilização indevida de tais credenciais
        de acesso, inclusive por terceiros, sem qualquer responsabilidade da <b>BTIME</b>. Todas as permissões
        atribuídas a cada usuário são de responsabilidade integral da <b>CONTRATANTE</b>, ficando a <b>BTIME</b> isenta
        de qualquer responsabilidade pela eventual atribuição de poderes indevidos a qualquer usuário.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.5.</b> É de responsabilidade exclusiva da <b>CONTRATANTE</b> o conteúdo disponibilizado aos seus
        funcionários, por meio do uso do <b>SOFTWARE</b>, ficando a <b>BTIME</b> e seus prepostos, eximidos de qualquer
        responsabilidade por informações incorretas ou de qualquer forma inapropriadas, que venham a ser exibidas pelo{' '}
        <b>SOFTWARE</b>, na interação com os clientes da <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.6.</b> A <b>BTIME</b> não tem obrigação de monitoramento do conteúdo disponibilizado por terceiros por meio
        do uso do <b>SOFTWARE</b> e não se responsabiliza por eventuais danos deles decorrentes. A <b>BTIME</b> se
        reserva ao direito de tomar ciência de notícia e excluir conteúdo em violação aos seus Termos de Uso e Política
        de Privacidade, disponível em{' '}
        <a href="https://www.btime.io/termosdeuso" style={{ textDecoration: 'none', color: 'inherit' }}>
          https://www.btime.io/termosdeuso
        </a>
        .
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.7.</b> A <b>BTIME</b> não garante que o <b>SOFTWARE</b> operará em combinações outras, que não aquelas para
        as quais foi especificado, nos termos do documento padrão de requisitos mínimos entregue à <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.8.</b> Não caberá responsabilidade a qualquer das partes pelo não cumprimento de suas obrigações
        contratuais caso o inadimplemento decorra de caso fortuito ou eventos de força maior, que impeçam, temporária ou
        definitivamente, o cumprimento de quaisquer obrigações assumidas neste contrato, conforme disposto no artigo 393
        do Código Civil.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>6.9.</b> A parte que se sentir impossibilitada de dar cumprimento às suas obrigações contratuais por fatos
        oriundos de caso fortuito ou eventos de força maior deverá comunicar a outra parte, no prazo máximo de 48
        (quarenta e oito) horas após a ocorrência, sob pena de não lhe ser possível invocar esta cláusula.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DAS CONDIÇÕES RELATIVAS À LICENÇA DE USO DO SOFTWARE E DA PROPRIEDADE INDUSTRIAL E INTELECTUAL</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.1.</b> O presente contrato não importa em transmissão de quaisquer direitos de propriedade industrial e/ou
        intelectual entre as partes, sendo seu objeto a mera disponibilização de programa de computador/mobile como
        serviço, acompanhado de licença de uso, tudo nos termos, limites, e condições previstas neste contrato e seu
        anexo.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.2.</b> Nos termos da cláusula 7.1, pertencem exclusivamente à <b>BTIME</b> os direitos de propriedade
        industrial e intelectual sobre o <b>SOFTWARE</b>, seu código fonte, sua documentação, e todos os seus
        componentes, tais como textos, imagens, marcas, relatórios, gráficos, e quaisquer outros, a estes não se
        limitando, cujo uso será disponibilizado como serviço à <b>CONTRATANTE</b>, observados os termos e condições
        deste instrumento.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.3.</b> É vedado à <b>CONTRATANTE</b> ceder, transferir, alugar, vender, comercializar a licença de uso do{' '}
        <b>SOFTWARE</b>, que não poderá beneficiar terceiros que não a <b>CONTRATANTE</b>, salvo com prévia e expressa
        autorização firmadas pelos representantes legais da <b>BTIME</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.4.</b> Considerando que o <b>SOFTWARE</b> é disponibilizado como serviço à <b>CONTRATANTE</b>, o backup das
        informações será realizado pela <b>BTIME</b>, de modo que é vedado à <b>CONTRATANTE</b> manter, em seu poder,
        qualquer cópia do <b>SOFTWARE</b>, que, se ocorrer, será considerada como cópia não autorizada, e sua mera
        existência será compreendida como violação de direitos autorais.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.5.</b> A <b>CONTRATANTE</b> não poderá, direta ou indiretamente, inclusive através de atos de seus
        prepostos ou terceiros a seu serviço, copiar, doar, modificar, transferir, sublicenciar, ceder, vender, dar em
        locação, dar em garantia, doar, ou alienar a terceiros o <b>SOFTWARE</b>, sob qualquer forma ou modalidade,
        gratuita ou onerosa, provisória ou permanente, no todo ou em parte, nem acessá-lo mediante a quebra de senhas,
        ou submetê-lo a processos de engenharia reversa ou, ainda, traduzi-lo ou decodificá-lo, no todo ou em parte,
        ficando ciente que a infração, total ou parcial, constituirá violação de direitos autorais. As mesmas vedações
        aplicam-se a quaisquer documentações ou informações relativas ao <b>SOFTWARE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.6.</b> É vedado à <b>CONTRATANTE</b> o acesso aos códigos fonte do <b>SOFTWARE</b>, para qualquer
        finalidade.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.7.</b> A titularidade de qualquer criação intelectual e/ou industrial decorrente dos serviços previstos
        neste contrato, ainda que sob encomenda da <b>CONTRATANTE</b>, pertencerá exclusivamente à <b>BTIME</b>, que
        poderá livremente utilizar, comercializar, e explorar tal criação, sem qualquer direito de objeção da{' '}
        <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>7.8.</b> A <b>CONTRATANTE</b> reconhece e declara que toda a tecnologia e <i>know how</i> empregado no
        desenvolvimento e implantação do <b>SOFTWARE</b>, decorrente de significantes investimentos da <b>BTIME</b>, é
        de titularidade exclusiva da <b>BTIME</b>, e não se transmite à <b>CONTRATANTE</b>, em razão do presente
        contrato.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DA CONFIDENCIALIDADE</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>8.1.</b> As partes se obrigam a manter o mais absoluto sigilo com relação a quaisquer dados, informações,
        materiais, pormenores, inovações, segredos comerciais, marcas, estratégias, relatórios, criações, designs,
        layouts, especificações técnicas e comerciais, dados pessoais, dentre outros, doravante denominados{' '}
        <b>“DADOS CONFIDENCIAIS”</b>, a que, diretamente ou através de seus funcionários e/ou prepostos, venham a ter
        acesso, conhecimento ou que venha a lhe ser confiado durante e em razão do presente instrumento. Comprometem-se,
        outrossim, a não revelar, reproduzir, utilizar ou dar conhecimento, em hipótese alguma, a terceiros, bem como a
        não permitir que nenhum de seus funcionários e/ou prepostos faça uso desses <b>“DADOS CONFIDENCIAIS”</b> de
        forma indevida.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>8.1.1.</b> A <b>BTIME</b> compromete-se a garantir a confidencialidade, inclusive por seus funcionários que,
        em razão de suas funções, tenham acesso aos <b>DADOS CONFIDENCIAIS</b> envolvidos nas atividades do presente
        Contrato, e por isso assumiram internamente compromisso de confidencialidade e foram instruídos sobre a
        importância de seu papel na Segurança da Informação e na Proteção de Dados Pessoais.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>8.2.</b> As partes poderão divulgar <b>DADOS CONFIDENCIAIS</b> conforme ordem judicial, desde que a parte que
        for realizar a divulgação notifique a outra parte, no mínimo 72 (setenta e duas) horas antes à referida
        divulgação, para que esta, querendo, promova as medidas necessárias e cabíveis para a proteção dos seus
        interesses.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>8.3.</b> As partes darão ciência imediata uma à outra sobre qualquer uso ou divulgação não autorizada dos{' '}
        <b>DADOS CONFIDENCIAIS</b>, ou de qualquer outra violação do presente Instrumento por si, ou por seus prepostos,
        e colaborarão mutuamente, de todas as formas possíveis, para recuperar a posse dos <b>DADOS CONFIDENCIAIS</b> e
        a impedir que seu uso não autorizado prossiga ou se amplie.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>8.4.</b> As partes não divulgarão quaisquer <b>DADOS CONFIDENCIAIS</b> a terceiros durante a vigência deste
        contrato, e por um período de 03 (três) anos após o encerramento ou eventual rescisão do presente instrumento,
        com ou sem justa causa, sem prejuízo do dever legal de confidencialidade em relação aos{' '}
        <b>DADOS CONFIDENCIAIS</b> que sejam consideradas segredo comercial sob a lei aplicável, que devem permanecer em
        vigor por prazo indeterminado até que tais Informações Confidenciais deixem de exibir tal qualidade..
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DA PROTEÇÃO DE DADOS PESSOAIS</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.1.</b> As <b>PARTES</b> declaram cumprir em suas atividades com a legislação de proteção de dados pessoais,
        inclusive, mas não limitada à Constituição Federal de 1988, o Código Civil de 2002, o Código de Defesa do
        Consumidor, a Consolidação das Leis do Trabalho, o Marco Civil da Internet e seu Decreto Regulamentador, a Lei
        Geral de Proteção de Dados Pessoais (“LGPD”).
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.1.1.</b> Para os fins de interpretação deste Contrato e de eventuais Aditivos, serão aplicadas as
        disposições da LGPD, inclusive suas definições.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.2.</b> Nas atividades de Tratamento de Dados Pessoais envolvidas no objeto deste Contrato, a <b>BTIME</b>{' '}
        atuará como Operador de Dados Pessoais, em nome e nos limites determinados pela <b>CONTRATANTE</b>, Controladora
        de Dados Pessoais, nos termos das cláusulas 3.1.1 e 5.1.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.3.</b> A <b>CONTRATANTE</b>, enquanto Controladora de Dados Pessoais, é a única responsável pela definição
        dos meios e das finalidades do Tratamento de Dados Pessoais, não sendo responsabilidade da <b>BTIME</b>{' '}
        controlar, fiscalizar e/ou averiguar o embasamento jurídico do tratamento de dados realizado pela{' '}
        <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.3.1.</b> A <b>CONTRATANTE</b> garante à <b>BTIME</b> que atende aos requisitos de transparência e
        informação trazidos pela LGPD, bem como que as atividades de tratamento de dados na utilização do{' '}
        <b>SOFTWARE</b> atendem a pelo menos uma das bases legais previstas nos artigos 7º e/ou 11 da referida Lei.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.3.2.</b> Se a <b>CONTRATANTE</b> utilizar a base legal do consentimento em atividades desenvolvidas no{' '}
        <b>SOFTWARE</b> da <b>BTIME</b>, a <b>CONTRATANTE</b> será a responsável pela coleta e gestão do consentimento.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.4.</b> Caso a <b>BTIME</b> venha a ser demandada, judicialmente ou extrajudicialmente, em razão de
        Tratamento irregular de Dados conduzido pela <b>CONTRATANTE</b>, esta última será obrigada a ressarcir todas e
        quaisquer despesas, custos (processuais ou administrativos), multas, indenizações, honorários advocatícios,
        periciais e/ou contábeis (a esses não se limitando) que a <b>BTIME</b> for obrigada a despender.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.5.</b> A <b>BTIME</b> garante que adota na realização das atividades objeto deste Contrato as medidas de
        segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de
        situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento
        inadequado ou ilícito, de acordo com os Termos de Uso e Política de Privacidade do <b>SOFTWARE</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.6.</b> A <b>BTIME</b> exigirá a manutenção do nível de segurança e proteção de dados pessoais nas
        atividades realizadas por terceiros para a execução do presente Contrato. O Tratamento de Dados praticado por
        tais terceiros será realizado de acordo com suas políticas e procedimentos em proteção de dados, sob os quais a{' '}
        <b>BTIME</b> não possui qualquer ingerência ou responsabilidade.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.7.</b> Em nenhuma hipótese a <b>BTIME</b> poderá ser responsabilizada pelo Tratamento dado pela{' '}
        <b>CONTRATANTE</b> em relação aos Dados Pessoais tratados pela <b>BTIME</b> ou seus subcontratados, em
        decorrência das instruções fornecidas pela <b>CONTRATANTE</b> ou das atividades desenvolvidas pela{' '}
        <b>CONTRATANTE</b> no <b>SOFTWARE</b> da <b>BTIME</b>.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.8.</b> Em caso de eventual solicitação, por parte dos Titulares de Dados, de quaisquer dos direitos
        previstos no art. 18 ou 20 da LGPD, a <b>BTIME</b> cooperará com as informações existentes no <b>SOFTWARE</b>{' '}
        com a <b>CONTRATANTE</b>, responsável por atender os pedidos dos Titulares ou, em caso de decisão pelo não
        atendimento da solicitação, por responder e interagir diretamente com o Titular dos Dados.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.9.</b> Encerrada a relação jurídica decorrente deste contrato, a <b>BTIME</b> armazenará os dados inseridos
        pela <b>CONTRATANTE</b> no <b>SOFTWARE</b>, inclusive os Dados Pessoais, pelo prazo de 03 (três) meses para
        Pequenas e Médias Empresas (<b>SMB</b>) e 06 (seis) meses para Grandes Empresas (<b>“Enterprise”</b>).
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>9.10.</b> Caso a <b>CONTRATANTE</b> não realize o download dos dados antes de encerrada a relação jurídica,
        poderá, dentro do referido prazo de 03 (três) meses para “Pequenas e Médias Empresas (<b>SMB</b>) e 06 (seis)
        meses para Grandes Empresas (<b>Enterprise</b>), solicitar o envio dos dados para a <b>BTIME</b>. Após o prazo
        de 03 (meses) para Pequenas e Médias Empresas (<b>SMB</b>) e 06 (seis) meses para Grandes Empresas (
        <b>Enterprise</b>) os dados serão deletados.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DA VIGÊNCIA E RESCISÃO</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>10.1.</b> O presente contrato terá vigência pelo prazo de 12 (doze) meses, a contar da data de assinatura,
        renovando-se automaticamente por iguais períodos, salvo manifestação contrária de qualquer das partes, mediante
        notificação por escrito com antecedência mínima de 30 (trinta) dias do término da vigência.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>10.2.</b> Caso qualquer das partes deseje rescindir este contrato de forma imotivada antes do término do
        prazo de vigência, deverá comunicar sua decisão por escrito, via e-mail com confirmação de recebimento.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>10.3.</b> No caso de rescisão imotivada unilateral por parte da <b>CONTRATANTE</b>, será devida à{' '}
        <b>CONTRATADA</b> multa compensatória no valor correspondente a 30% (trinta por cento) do saldo remanescente do
        contrato até o final do período de 12 (doze) meses, salvo negociação diversa entre as partes.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>10.4.</b> Este contrato será considerado automaticamente rescindido, independentemente de qualquer
        formalidade adicional e sem ônus, no caso de falência, liquidação ou recuperação judicial ou extrajudicial de
        qualquer das partes.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>10.5.</b> Em qualquer hipótese de término ou rescisão do presente contrato, a <b>CONTRATANTE</b> permanecerá
        responsável pelo pagamento dos valores devidos à <b>CONTRATADA</b> pelos serviços efetivamente prestados até a
        data da rescisão, além da multa prevista nesta cláusula, se aplicável.
      </Text>

      <Separator weight={5} />

      <Text semibold>
        <u>DAS DISPOSIÇÕES GERAIS</u>
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>11.1.</b> É vedado às partes ceder ou transferir a terceiros os direitos e obrigações decorrentes do presente
        instrumento, total ou parcialmente, salvo se com a concordância prévia e expressa da outra parte.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>11.2.</b> Este contrato obriga as partes e seus sucessores, a qualquer título, e não cria entre as partes
        nenhum tipo de vínculo empregatício, sociedade, associação, consórcio, ou qualquer outro tipo de relação que não
        a contratação autônoma de prestação de serviços.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>11.3.</b> No caso de quaisquer conflitos entre os termos deste contrato e da proposta comercial, este
        contrato prevalecerá.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>11.4.</b> A tolerância de uma parte para com a outra, relativamente a descumprimento de qualquer das
        obrigações ora assumidas, não será considerada novação ou renúncia a qualquer direito, constituindo mera
        liberalidade, que não impedirá a parte tolerante de exigir da outra o fiel cumprimento deste contrato, a
        qualquer tempo.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>11.5.</b> As partes elegem o Foro da Comarca de São Paulo, com renúncia expressa a qualquer outro, por mais
        privilegiado que seja ou venha a ser, para dirimir qualquer dúvida ou controvérsia decorrente da interpretação
        ou execução do presente contrato, que será regido e interpretado de acordo com as Leis vigentes na República
        Federativa do Brasil.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        <b>11.1.</b> As Partes concordam que o presente Contrato, pode ser assinado digitalmente, nos termos da Lei n.º
        13.874/2019, bem como na Lei n.º 14.063/2020, Medida Provisória 2.200-2/2001, no Decreto 10.278, e ainda, no
        Enunciado n.º 297 do Conselho Nacional de Justiça.
      </Text>
      <Separator weight={2} />
      <Text align="justify">
        E por estarem acordadas, as partes assinam o presente instrumento em 2 (duas) vias de igual teor e forma,
        juntamente com duas testemunhas, para os devidos fins e efeitos de direito.
      </Text>
    </div>
  )
}

export default ContratoSection
